import { useMemo, useState } from "react";

import { DeleteForeverOutlined } from "@mui/icons-material";
import { Dialog, useMediaQuery } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import TilleyDataGrid from "components/shared/DataGrid/TilleyDataGrid";
import { formatDate } from "utility/formatters";

import { EditIcon } from "../../Icons/Icons";
import { NewUserDialog } from "./NewUserDialog";

export const MEMBER_ACTION_MANAGE_ACCOUNT = "manage_account";

export default function MemberUserDataTable({
  users,
  member,
  isLoading,
  onDeleteUser,
  pageSizes = [5, 10, 25, 50, 100],
  rowHeight = 80,
}) {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("lg"), { noSsr: true });

  const [selectedUser, setSelectedUser] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const COLUMNS_MEMBERS = useMemo(
    () => [
      {
        field: "description",
        headerName: "Name",
        flex: 1.5,
      },
      {
        field: "email",
        headerName: "Email",
        flex: 2,
      },
      {
        field: "lastupdate",
        headerName: "Last Updated",
        flex: 1,
        valueGetter: (value) => formatDate(value),
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        headerAlign: "right",
        align: "right",
        width: 150,
        sortable: false,
        getActions: (params) => {
          return [
            <GridActionsCellItem
              key="edit"
              label="Edit"
              size="small"
              onClick={() => {
                setSelectedUser(params.row);
                setIsEdit(true);
              }}
              icon={<EditIcon sx={{ color: "text.primary" }} />}
            />,
            <GridActionsCellItem
              key="delete"
              label="Delete"
              size="small"
              onClick={() => {
                if (onDeleteUser) {
                  onDeleteUser(params.row);
                }
              }}
              icon={<DeleteForeverOutlined sx={{ color: "error.main" }} />}
            />,
          ];
        },
      },
    ],
    []
  );

  return (
    <>
      <TilleyDataGrid
        rows={users || []}
        columns={COLUMNS_MEMBERS}
        pageSizeOptions={pageSizes}
        defaultPageSize={isMobile ? 5 : 10}
        gridKey="member-user-grants"
        getRowId={(row) => row.id}
        rowHeight={rowHeight}
        isLoading={isLoading}
        sx={{ width: "99%", boxSizing: "border-box" }}
      />

      <Dialog open={selectedUser}>
        <NewUserDialog
          isEdit={isEdit}
          member={member}
          selectedUser={selectedUser}
          onClose={() => {
            setSelectedUser(null);
          }}
        />
      </Dialog>
    </>
  );
}
